// ----------------------------------------------------------------------------
// Component: Comparison Chart
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';
import './_comparison-chart.scss';
